import React, { useEffect, useState } from "react";
import { fetchProducts } from "../lib/shopify";
import { T } from "../theme";
import { Card, TapeIcon } from "../ui";

export default function MerchScreen({ cartQuantity, onSelectProduct, onOpenCart }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchProducts()
      .then((p) => { if (!cancelled) { setProducts(p); setError(""); } })
      .catch((e) => { if (!cancelled) setError(e.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
        <button onClick={onOpenCart} style={{ background: T.statBg, border: `1px solid ${T.border}`, color: T.text, padding: "6px 14px", borderRadius: 20, fontSize: 12, cursor: "pointer", fontFamily: T.font }}>
          🛍 Cart {cartQuantity > 0 ? `(${cartQuantity})` : ""}
        </button>
      </div>

      {loading && <div style={{ textAlign: "center", padding: 32, color: T.muted, fontSize: 13 }}>Loading merch…</div>}

      {!loading && error && (
        <Card style={{ textAlign: "center", padding: 24 }}>
          <div style={{ fontSize: 13, color: "#C0392B", marginBottom: 6 }}>Couldn't load the shop.</div>
          <div style={{ fontSize: 11, color: T.muted }}>{error}</div>
        </Card>
      )}

      {!loading && !error && products.length === 0 && (
        <Card style={{ textAlign: "center", padding: 32 }}>
          <div style={{ fontSize: 13, color: T.muted }}>No merch listed yet — check back soon.</div>
        </Card>
      )}

      {!loading && !error && products.length > 0 && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {products.map((p) => (
            <div key={p.id} onClick={() => onSelectProduct(p)} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, padding: 12, cursor: "pointer" }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
                {p.imageUrl ? (
                  <img src={p.imageUrl} alt={p.imageAlt} style={{ width: "100%", height: 110, objectFit: "cover", borderRadius: 6 }} />
                ) : (
                  <TapeIcon size={52} />
                )}
              </div>
              <div style={{ fontSize: 12, fontWeight: "bold", color: T.text, marginBottom: 2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.title}</div>
              <div style={{ fontSize: 13, fontWeight: "bold", color: T.value }}>${Number(p.minPrice).toFixed(2)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
